module.exports = __webpack_public_path__ + "img/ar.bb25c2fb.svg";